/**
 * Popover for text type field editing on editor page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Label, InputArea, TextArea, RadioGroup } from 'wix-style-react'
// import TextIcon from 'react-icons/lib/fa/font'
// import StyleIcon from 'react-icons/lib/fa/paint-brush'

import PopoverHeader from './PopoverHeader'
// import CustomTabs from './CustomTabs'
// import CustomCSSInput from './CustomCSSInput'
import CustomCSSView from './customCSS/CustomCSSView'
// controllers
import { setCustomFieldArray } from 'controllers/logic'

const Container = styled.div`
  _height: 26em;
  width: 20em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);
`
const TextInputContainer = styled.div`
  padding: 1.3em 1.5em 1.3em 1.5em;
`
const Content = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  flex-direction: column;
`

const TypeContainer = styled.div`
  height: 100%;
  color: #000;
  background: #fff;
  font-size: 14px;
  padding: 10px 30px;
  border-bottom: 1px solid #3899ec;
`

class TextPopover extends Component {

  constructor () {
    super()

    this.state = {
      activeTab: 0,
      activeRadio: ''
    }
  }

  componentWillMount () {
    this.props.updatePosition('15%', '57%')
  }

  onItemClick = (item) => this.setState({ activeTab: item.id })

  onInputChange = (e) => {
    const { value } = e.target
    console.log('onInputChange', value)
    const { app, dispatch, path } = this.props
    if (path) {
      dispatch(setCustomFieldArray(app.id, path, value))
    }
  }

  renderEditCSS () {
    return (
      <CustomCSSView
        field={this.props.field}
        app={this.props.app}
      />
    )
  }

  renderEditText () {
    return (
      <TextInputContainer>
        <TextArea>
          <Label appearance='T1.1' for='firstName'>
            Edit Text
          </Label>
          <InputArea
            id='firstName'
            maxHeight='80px'
            maxLength={240}
            minHeight='40px'
            placeholder={this.props.value}
            value={this.props.value}
            rows={2}
            theme='normal'
            onChange={this.onInputChange}
          />
        </TextArea>
      </TextInputContainer>
    )
  }

  renderContent () {
    switch (this.props.popoverSection) {
      case 'text':
        return this.renderEditText()
      case 'design':
        return this.renderEditCSS()
      default:
        return null
    }
  }

  renderTipTypeChooser () {
    const { app, dispatch, path, field } = this.props
    if (field.id !== 'tip') return null
    const onChange = (val) => {
      this.setState({
        activeRadio: val
      })
      if (path) {
        dispatch(setCustomFieldArray(app.id, [path[0], 'tipType'], val))
      }
    }
    return (
      <TypeContainer>
        <span>Choose Tip type:</span>
        <RadioGroup value={this.state.activeRadio} onChange={val => onChange(val)} display='horizontal'>
          <RadioGroup.Radio value={'text'}>Text</RadioGroup.Radio>
          <RadioGroup.Radio value={'appLinks'}>App Links</RadioGroup.Radio>
        </RadioGroup>
      </TypeContainer>

    )
  }

  render () {
    const { app, field, closeMyself } = this.props
    return (
      <Container>
        <PopoverHeader
          headingDescriptor='Design'
          // title={this.props.title}
          onClose={closeMyself}
          helpTooltip={'Input a text for the field'}
          app={app}
          field={field}
        />
        <Content>
          {this.renderTipTypeChooser()}
          {this.renderContent()}
        </Content>
      </Container>
    )
  }
}

TextPopover.propTypes = {
  closeMyself: PropTypes.func,
  value: PropTypes.string,
  path: PropTypes.array,
  // title: PropTypes.string,
  field: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  updatePosition: PropTypes.func,
  popoverSection: PropTypes.string
}

export default connect()(TextPopover)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/TextPopover.js